<template>
  <v-card outlined>
    <v-container class="px-1 py-1" fluid>
      <v-card-title class="pt-2 pb-0">
        {{ $t('ELE0028') }}
      </v-card-title>
      <v-card-text>
        <validation-observer ref="observer" v-slot="{ invalid }">
          <v-row class="pt-4" align-content="center">
            <v-col cols="12" md="8">
              <v-row class="pt-2 pb-2">
                <v-card-text class="pt-2 pl-3 pb-0"> {{ $t('ELE0329') }} </v-card-text>
                <span style="width: 100px">
                  <TextFieldInput label="" type="number" v-model="searchCondition.passes" rules="minAndMaxValue" />
                </span>
                <v-card-text class="pt-2 pl-3 pb-0"> {{ $t('ELE0253') }} </v-card-text>
                <span class="ml-4">
                  <TextFieldInputWithDatePicker
                    :label="$t('ELE0128')"
                    required
                    v-model="searchCondition.dateFrom"
                    disableFutureDate
                  />
                </span>
              </v-row>
            </v-col>
            <v-col class="d-flex align-center justify-end">
              <BtnSearch @click="onClickSearch" :disabled="invalid" />
            </v-col>
          </v-row>
        </validation-observer>
        <v-row>
          <v-col>
            <v-card outlined>
              <v-card-title class="pt-1 pb-0">
                {{ $t('ELE0023') }}
              </v-card-title>
              <v-data-table :headers="headers" :items="items" dense>
                <template v-slot:[`item.check`]="{ item }">
                  <v-simple-checkbox label="" v-model="item.checked" :ripple="false" color="primary" />
                </template>
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-text class="pt-0 pb-4 d-flex align-center justify-end">
        <Btn :label="$t('ELE0336')" @click="onClickSet" :disabled="!disableComputed" />
      </v-card-text>
    </v-container>
  </v-card>
</template>
<script>
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtils from '@/mixin/date-utils.js'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker'
import { extend, ValidationObserver } from 'vee-validate'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import Btn from '@/components/atoms/base/button/Btn'
import moment from 'moment'

export default {
  name: 'InspFilteringUpdatePage',

  mixins: [APIUtils, Message, Loading, DateUtils],

  components: {
    TextFieldInput,
    TextFieldInputWithDatePicker,
    BtnSearch,
    Btn,
    ValidationObserver,
  },

  data() {
    return {
      searchCondition: {
        passes: 5,
        dateFrom: moment().subtract(1, 'M').format('YYYY-MM-DD'),
      },
      headers: [
        { text: this.$t('ELE0330'), divider: true, align: 'center', value: 'check', sortable: false },
        { text: this.$t('ELE0031'), divider: true, value: 'partCd' },
        { text: this.$t('ELE0032'), divider: true, value: 'partName' },
        { text: this.$t('ELE0331'), divider: true, value: 'partGroupName' },
        { text: this.$t('ELE0332'), divider: true, value: 'fromFilteringGroupCd' },
        { text: this.$t('ELE0333'), divider: true, value: 'toFilteringGroupCd' },
        { text: this.$t('ELE0334'), divider: true, align: 'right', value: 'passedLot' },
        { text: this.$t('ELE0335'), divider: true, value: 'lastInspDate' },
      ],
      items: [],
      selectedParts: [],
    }
  },

  computed: {
    disableComputed: {
      get() {
        return this.items.filter((item) => item.checked)?.length > 0
      },
    },
  },

  methods: {
    async onClickSearch() {
      this.startLoading()
      try {
        const data = await API.get('/master/inspFilter', this.searchCondition)
        // console.log(data)
        if (data) {
          this.items = data.map((item) => {
            return {
              partCd: item.partCd,
              partName: item.partName,
              partGroupName: item.partGroupName,
              fromFilteringGroupCd: item.fromFilteringGroupName,
              toFilteringGroupCd: item.toFilteringGroupName,
              passedLot: item.passedLot,
              lastInspDate: moment(item.lastInspDate).format('YYYY-MM-DD'),
              checked: false,
            }
          })
        }
      } catch (error) {
        this.items = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0143') })))
      } finally {
        this.stopLoading()
      }
    },
    async registerInspFiltering(partList) {
      const params = partList
      this.startLoading()
      try {
        await API.post('/master/filtering/register', params)
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0143') })))
      } finally {
        this.onClickSearch()
        this.stopLoading()
      }
    },
    onClickSet() {
      const registerPartCdlist = this.items
        .filter((item) => item.checked)
        ?.map((obj) => {
          return {
            partCd: obj.partCd,
            inspFiltering: obj.toFilteringGroupCd,
          }
        })
      this.registerInspFiltering(registerPartCdlist)
    },
  },
  mounted() {
    extend('minAndMaxValue', {
      validate: (value) => {
        if (value >= 5 && value <= 99) return true
        else return this.$t('MSG0026', { p0: this.$t('ELE0329'), p1: '5', p2: '99' })
      },
    })
  },
}
</script>
